import request from '@hotmart/request'
import { Dispatch } from '@reduxjs/toolkit'
import { userSlice } from '../slices'
import { USER_CLUSTERS_INITIALS, USER_REQUEST_IDENTIFIERS } from '../user.constants'

const noClusterValue = {
  clusterId: 0,
  clusterName: 'No Cluster',
  clusterInitials: ''
}

function getCluster() {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const clusterResponse = await request(USER_REQUEST_IDENTIFIERS.CLUSTER)

      if (clusterResponse) {
        const cluster = {
          ...clusterResponse,
          clusterInitials: USER_CLUSTERS_INITIALS[clusterResponse.clusterName] || ''
        }

        dispatch(userSlice.actions.updateUser({ cluster }))
      } else {
        dispatch(userSlice.actions.updateUser({ cluster: { ...noClusterValue } }))
      }
    } catch (error) {
      dispatch(userSlice.actions.updateUser({ cluster: { ...noClusterValue } }))
      console.error('BW:', 'Error when trying to cluster information', error)
    }
  }
}

export default getCluster
